import { useState, useEffect } from 'react';
import Bowser from 'bowser';

const useDeviceTypeAndOrientation = () => {
    const [deviceInfo, setDeviceInfo] = useState({
        platform: '',
        orientation: 'landscape',
    });

    useEffect(() => {
        const userAgent = window.navigator.userAgent;
        const parser = Bowser.getParser(userAgent);
        const platform = parser.getPlatformType();

        const portraitQuery = window.matchMedia('(orientation: portrait)');
        const initialOrientation = portraitQuery.matches ? 'portrait' : 'landscape';

        setDeviceInfo({ platform, orientation: initialOrientation });

        const handleOrientationChange = (event) => {
            setDeviceInfo(prev => ({
                ...prev,
                orientation: event.matches ? 'portrait' : 'landscape'
            }));
        };

        portraitQuery.addEventListener('change', handleOrientationChange);

        return () => {
            portraitQuery.removeEventListener('change', handleOrientationChange);
        };
    }, []);

    const isSupported = !(
        (deviceInfo.platform === 'mobile') ||
        (deviceInfo.platform === 'tablet' && deviceInfo.orientation === 'portrait'));

    return { ...deviceInfo, isSupported };
};

export default useDeviceTypeAndOrientation;